import React from "react";

import "./QrCodeDisplay.scss";
import QrSvg from "@wojtekmaj/react-qr-svg";

export default function QrCodeDisplay({ value, width, onCodeClick }) {

	const on_click = () => {
		onCodeClick?.();
	}

	return (
		<div className="qr-code-display">
			<div className="qr-holder" onClick={on_click}>
				<QrSvg value={value} width={width ?? 250} />
			</div>
		</div>
	);
}